module.exports = __webpack_public_path__ + "assets/images/JMD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD50.png
// module id = 1387
// module chunks = 1